import React from 'react';
import { View, ViewProps } from 'react-native';
import { gestureHandlerRootHOC } from 'react-native-gesture-handler';

/**
 * On Android RNGH does not work by default because modals are not located under React Native Root view in native hierarchy.
 * In order to make it workable, components need to be wrapped with gestureHandlerRootHOC (it's no-op on iOS and web).
 * @see https://docs.swmansion.com/react-native-gesture-handler/docs/#usage-with-modals-on-android
 */
export const GestureHandlerRoot = gestureHandlerRootHOC<ViewProps>(({ children, ...props }) => (
  <View {...props}>{children}</View>
));
